export const BRAINTREE_SDK_STABLE_VERSION = '3.106.0';
